import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-300">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="font-heading text-lg font-semibold text-white mb-4">
                Sugargoo Spreadsheet
              </h4>
              <p className="text-sm leading-relaxed text-secondary-400">
                The most complete Sugargoo research database. Find better products, compare prices, and understand quality before buying.
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                Quick Links
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Complete Guide
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-review" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Sugargoo Review
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-shipping-cost" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Shipping Cost Guide
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Shop Now
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                SEO Guides
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/sugargoo-coupon" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Coupon &amp; Discounts
                  </Link>
                </li>
                <li>
                  <Link to="/is-sugargoo-legit" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Is Sugargoo Legit?
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-warehouse" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Warehouse Guide
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-best-finds" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Best Finds 2026
                  </Link>
                </li>
                <li>
                  <Link to="/sugargoo-buying-guide" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Buying Guide
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                Shop Categories
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Shoes
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Hoodies &amp; Sweaters
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    T-Shirts
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Jackets
                  </a>
                </li>
                <li>
                  <Link to="/sugargoo-quality-check" className="text-sm text-secondary-400 hover:text-accent-300 transition-colors duration-150 whitespace-nowrap">
                    Quality Check Guide
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-secondary-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All rights reserved. This is an independent resource and is not affiliated with Sugargoo.
            </p>
            <p className="text-xs text-secondary-600">
              External links open in new tabs. We may earn from qualifying purchases.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}